import React from 'react';
import { SITE_CONTENT } from '../content';

const MapSection = () => {
  const mapData = SITE_CONTENT.pages?.contactUsPage?.mapSection || {};
  const title = mapData.title || "Our Location";
  const mapSrc = mapData.mapSrc || "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15632.748057279316!2d78.1408104!3d11.6491763!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3babf1c080000001%3A0x6b1064e43e74ff1f!2sSalem%2C%20Tamil%20Nadu!5e0!3m2!1sen!2sin!4v1714571987541!5m2!1sen!2sin";
  return (
    <section className="bg-[#f0eee5] pb-20 lg:pb-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="w-full h-[400px] lg:h-[450px] shadow-sm">
          <iframe 
            title={title}
            // The London Eye map embed coordinates based on the screenshot
            src={mapSrc}
            className="w-full h-full border-0 grayscale hover:grayscale-0 transition-all duration-700 ease-in-out bg-gray-200"
            allowFullScreen="" 
            loading="lazy" 
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
    </section>
  );
};

export default MapSection;
